import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Italic = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M6.5 19L6.85399 17.4688H9.40625L12.4688 6.54688H9.91649L10.2389 5H16.9631L16.6406 6.54688H14.2188L11.1562 17.4688H13.5781L13.2241 19H6.5Z"
        fill={color}
      />
    </svg>
  )
})

export default Italic
